import { crmLevelTypeAliasesForTicketType } from './crmCommunicationTypeAliases';
import { isTicketCompanyContractor } from './crmCommunicationContractorAccess';

/**
 * Používateľ patrí do CRM úrovne (user alebo oddelenie) – parita ServiceTaskDetail::isUserInLevel.
 */
export function isUserInCrmLevel(state, user, levelId) {
  const lid = Number(levelId);
  if (!lid || !user) return false;
  const settings = (state?.crm_level_user_settings || []).filter(
    (s) => Number(s?.crm_level_id) === lid,
  );
  const deptId = Number(user?.employee?.department_id);
  return settings.some((setting) => {
    if (setting?.user_id != null) return Number(setting.user_id) === Number(user.id);
    if (setting?.user_id == null && setting?.department_id != null) {
      return deptId > 0 && Number(setting.department_id) === deptId;
    }
    return false;
  });
}

function userHasAdminOverride(user) {
  if (user?.is_superuser) return true;
  const roles = Array.isArray(user?.roles) ? user.roles : [];
  return roles.some((r) => (typeof r === 'string' ? r === 'admin' : String(r?.name || '').toLowerCase() === 'admin'));
}

/**
 * Môže meniť deadline – parita ServiceTaskDetail::isUserApproverOrManager.
 *
 * @param {{ type?: string, approval_requests?: Array<{ level_id?: number }>, approval?: Array<{ level_id?: number }>, cancelled_at?: string|null }} ticket
 * @param {boolean} workflowLocked Terminálny tiket (workflow_locked / final stav)
 */
export function canUserEditCrmCommunicationDeadline(ticket, user, state, workflowLocked = false) {
  if (!ticket || !user) return false;
  if (workflowLocked || ticket.cancelled_at) return false;
  const type = String(ticket.type || '');
  if (type !== 'acquisition' && type !== 'quote_request') return false;
  if (userHasAdminOverride(user)) return true;
  if (Number(ticket.created_by_user_id) === Number(user.id)) return true;
  if (isTicketCompanyContractor(ticket, user)) return true;

  const approvalList = Array.isArray(ticket.approval_requests)
    ? ticket.approval_requests
    : (Array.isArray(ticket.approval) ? ticket.approval : []);

  for (const row of approvalList) {
    const levelId = row?.level_id;
    if (levelId != null && isUserInCrmLevel(state, user, levelId)) {
      return true;
    }
  }

  const aliases = crmLevelTypeAliasesForTicketType(type);
  const managementLevels = (state?.crm_levels || []).filter(
    (lvl) => String(lvl?.task || '') === 'management' && aliases.includes(String(lvl?.type || '')),
  );

  return managementLevels.some((lvl) => isUserInCrmLevel(state, user, lvl.id));
}
